import { QRCodePage } from './QRCodePage';
export default QRCodePage;
